export default __webpack_public_path__ + "media/triangle-white-pattern.18c83797.png";